import _toConsumableArray from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { initUserState } from '@vip-activity/business';
import { mapActions, mapGetters, mapState } from 'vuex';
import Storage from '@tencent/vft-common/Storage';
import env from '@tencent/vft-common/env';
import tenvideo from '@tencent/vft-common/tenvideo';
import { BatchService } from '@/service';
import Header from './header/header.vue';
import TaskPanel from './task-panel/task-panel.vue';
import GiftCard from './gift-card/gift-card.vue';
import Guanzhu from './guanzhu/guanzhu.vue';
import Sport from './sport/sport.vue';
import Film from './film/film.vue';
import Act from './act/act.vue';
import Match from './match/match.vue';
import PopShare from './popup/pop-share/pop-share.vue';
import PopFull from './popup/pop-full/pop-full.vue';
import PopGame from './popup/pop-game/pop-game.vue';
import PopReward from './popup/pop-reward/pop-reward.vue';
import PopBatchReward from './popup/pop-batch-reward/pop-batch-reward.vue';
import FixBottom from './fix-bottom/fix-bottom.vue';
var _window = window,
    TencentSports = _window.TencentSports;
var errorMap = {
  '-1006': '活动未开始',
  '-1007': '活动已结束',
  '-1011': '您今日助力已达到上限',
  // 我去好友家串门拜年啦，咱们明天再见吧~
  '-1013': '您今日给TA拜过年啦',
  '-1014': '好友助力已满',
  // 我今天的拜年礼物已经发完啦，咱们明天再见吧~
  '-1016': '分享过期了',
  '-1017': '主人今天还没有准备好拜年礼物哦，快喊ta做好准备邀请客人吧~'
}; // 主人态游戏弹窗key

var SPORT_CNY_MASTER_GAME_POP = 'SPORT_CNY_MASTER_GAME_POP';
export default {
  components: {
    Header: Header,
    TaskPanel: TaskPanel,
    GiftCard: GiftCard,
    Guanzhu: Guanzhu,
    Sport: Sport,
    Film: Film,
    Act: Act,
    Match: Match,
    PopShare: PopShare,
    PopFull: PopFull,
    PopGame: PopGame,
    PopReward: PopReward,
    PopBatchReward: PopBatchReward,
    FixBottom: FixBottom
  },
  data: function data() {
    return {
      showFullPop: false,
      showGamePop: false,
      showSharePop: false,
      showRewardPop: false,
      showGuestRewardPop: false,
      showMasterRewardPop: false,
      showPopArray: [],
      currentPop: null,
      lotteryPopConfig: null,
      shareInfo: null,
      assistFullCode: 0,
      // 助力已满的代码
      masterRewardData: null,
      guestRewardData: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['assistModId'])), mapState(['openStatus', 'nbaVip', 'remainNum'])),
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return initUserState();

            case 2:
              // 登录初始化
              _this.bindEvent(); // 绑定监听事件


              _this.initState(); // 事件状态初始化


              _this.$report.ready(); // 数据上报初始化


              _this.bindPageAppearEvent();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['getLotteryCount', 'getAssistList', 'getBeAssistList', 'getSportVip', 'getOpenState'])), {}, {
    // 弹框队列  popName 不传，表示关闭pop
    nextShowPop: function nextShowPop(popName) {
      if (popName) {
        this.showPopArray.push(popName);
      } else {
        this.currentPop = null;
      }

      if (this.currentPop) return;
      var topPop = this.showPopArray.splice(-1, 1)[0];

      if (topPop) {
        this[topPop] = true;
        this.currentPop = topPop;
      }
    },
    initState: function initState() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.loginService.isLogin) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return Promise.all([_this2.sendRewardsWhenEnter(), _this2.checkAssistStatus()]);

              case 4:
                _this2.getAssistList(); // 获取已助力用户列表


                _this2.getBeAssistList(); // 获取被助力的用户列表


                _context2.next = 8;
                return _this2.getLotteryCount();

              case 8:
                _this2.getOpenState().then(_this2.checkMasterGamePop); // 查询四种套餐的开通状态并弹窗
                // 批量抽奖


                _context2.next = 11;
                return _this2.handleBatchLotteryRes();

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    bindEvent: function bindEvent() {
      var _this3 = this;

      // 展示中奖弹窗
      this.eventBus.$on('showReward', function (data, func) {
        _this3.lotteryPopConfig = data;

        _this3.nextShowPop('showRewardPop');

        if (func) {
          func();
        }
      }); // 拉起分享

      this.eventBus.$on('launchShare', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, func) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (_this3.loginService.isLogin) {
                    _context3.next = 3;
                    break;
                  }

                  _this3.$openLogin();

                  return _context3.abrupt("return");

                case 3:
                  _context3.next = 5;
                  return _this3.magicService.createAssist(_this3.assistModId)["catch"](function (e) {
                    _this3.toast("".concat(e.msg || e.message, "\u3010").concat(e.code, "\u3011"));

                    return Promise.reject(e);
                  });

                case 5:
                  _this3.shareInfo = data;

                  _this3.nextShowPop('showSharePop');

                  if (func) {
                    func();
                  }

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 检查助力
    checkAssistStatus: function checkAssistStatus() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var code;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.delUrlParams(['mvuid']);

                if (!(!_this4.mvuid || +_this4.mvuid === +_this4.vuid)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;
                _context4.next = 6;
                return _this4.magicService.doAssist(_this4.assistModId, {
                  id: _this4.mvuid
                });

              case 6:
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](3);
                // 助力失败
                code = _context4.t0.code; // 好友助力已满

                if (code === -1011 || code === -1014 || code === -1017) {
                  _this4.assistFullCode = code;

                  _this4.nextShowPop('showFullPop');
                } else if (errorMap["".concat(code)]) {
                  _this4.toast(errorMap[code]);
                } else {
                  _this4.toast("".concat(_context4.t0.message));
                }

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 8]]);
      }))();
    },
    // 查询主态抽奖弹窗
    checkMasterGamePop: function checkMasterGamePop() {
      // 弹窗活动期间内最多展示一次
      var hasLottery = +Storage.get(SPORT_CNY_MASTER_GAME_POP);
      if (hasLottery) return; // 是否有开通过其中一个套餐

      var hasOpenAtLeastOnce = Object.values(this.openStatus).some(function (v) {
        return !!v;
      }); // 当前抽奖次数

      var vipLeftNum = this.remainNum.vip;

      if (hasOpenAtLeastOnce && vipLeftNum > 0) {
        this.nextShowPop('showGamePop');
        Storage.set(SPORT_CNY_MASTER_GAME_POP, 1);
      }
    },

    /* 进页面送积分 */
    sendRewardsWhenEnter: function sendRewardsWhenEnter() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this5$setting$魔方$进页面, vipMod, svipMod, modId;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return _this5.getSportVip();

              case 3:
                _this5$setting$魔方$进页面 = _this5.setting.魔方.进页面送积分, vipMod = _this5$setting$魔方$进页面.vip, svipMod = _this5$setting$魔方$进页面.svip;
                modId = _this5.nbaVip === 2 ? svipMod : _this5.nbaVip === 1 ? vipMod : '';

                if (modId) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return");

              case 7:
                _context5.next = 9;
                return _this5.magicService.sendRewardsWhenEnter({
                  module_id: modId
                });

              case 9:
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);
                console.error('进页面送积分失败', _context5.t0);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 11]]);
      }))();
    },
    // 处理批量抽奖的结果
    handleBatchLotteryRes: function handleBatchLotteryRes() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _ref2;

        var _this6$setting$魔方$抽奖, guestMod, masterMod, _this6$remainNum, guestLeftNum, masterLeftNum, res, list, shieldList;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this6$setting$魔方$抽奖 = _this6.setting.魔方.抽奖, guestMod = _this6$setting$魔方$抽奖.guest, masterMod = _this6$setting$魔方$抽奖.master;
                _this6$remainNum = _this6.remainNum, guestLeftNum = _this6$remainNum.guest, masterLeftNum = _this6$remainNum.master;
                console.log(guestLeftNum, masterLeftNum);
                _context7.next = 5;
                return Promise.all([BatchService.doLottery(guestMod, guestLeftNum > 3 ? 3 : guestLeftNum), BatchService.doLottery(masterMod, masterLeftNum > 3 ? 3 : masterLeftNum)]);

              case 5:
                res = _context7.sent;
                list = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(res));
                console.log(list); // 判断请求中是否有905

                shieldList = list.filter(function (v) {
                  return v.code === -905;
                });

                if (shieldList.length > 0) {
                  _this6.magicService.pullShieldRun(shieldList[0], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return _this6.handleBatchLotteryRes();

                          case 2:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  })));
                } else {
                  if (res[0].length > 0) {
                    _this6.nextShowPop('showGuestRewardPop');

                    _this6.guestRewardData = {
                      index: 0,
                      list: res[0]
                    };
                  }

                  if (res[1].length > 0) {
                    _this6.nextShowPop('showMasterRewardPop');

                    _this6.masterRewardData = {
                      index: 1,
                      list: res[1]
                    };
                  }
                }

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 监听页面出现事件
    bindPageAppearEvent: function bindPageAppearEvent() {
      var _this7 = this;

      if (env.isApp) {
        tenvideo.tenvideoReady(function () {
          window.TenvideoJSBridge.on('onPageAppear', function () {
            _this7.getLotteryCount();
          });
        });
      } else if (env.isQQSports) {
        window.addEventListener('qqsports.show', function () {
          _this7.getLotteryCount();
        });
      }
    }
  })
};